import { faShop } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import phonepeimage from '../../assets/images/phonepe.png';
import Swalaleart from '../../function/swalaleart';
import { Link, useNavigate } from 'react-router-dom';



function Marketplace() {
    const navigate = useNavigate();

    const marketplaces = [
    {
        name: 'Google Sheets',
        image: 'https://upload.wikimedia.org/wikipedia/commons/a/ae/Google_Sheets_2020_Logo.svg',
        isActive: true,
    },
    {
        name: 'Shopify',
        image: 'https://upload.wikimedia.org/wikipedia/commons/0/0e/Shopify_logo_2018.svg',
        isActive: false,
    },
    {
        name: 'WordPress',
        image: 'https://upload.wikimedia.org/wikipedia/commons/9/98/WordPress_blue_logo.svg',
        isActive: false,
    },
    {
        name: 'PhonePe',
        image: phonepeimage,
        isActive: false,
    },
    {
        name: 'Razorpay',
        image: 'https://upload.wikimedia.org/wikipedia/commons/8/89/Razorpay_logo.svg',
        isActive: false,
    },
    ];

    return (
        <div className="container-fluid dashboard-main pt-0">
            <div className="card">
                <div className="card-body">
                <h4 className="card-title mb-4">
                    <FontAwesomeIcon icon={faShop} className="me-2" />
                    Marketplace Product
                </h4>

                <div className="d-flex gap-4 flex-wrap">
                    {marketplaces.map((item, index) => (
                    <div
                        onClick={() => {
                            if(!item.isActive){
                                Swalaleart({
                                    title: "Coming Soon",
                                    text: `${item.name} integration is coming soon! Stay tuned for updates.`,
                                    icon: "info",
                                    confirmColor: "#0d6efd",
                                });
                            }else{
                                navigate("/client-area/whatsapp/marketplace/googlesheet/manage");
                            }
                        }}
                        key={index}
                        className="text-center border rounded p-3"
                        style={{
                        width: '150px',
                        cursor: 'pointer',
                        transition: '0.2s',
                        }}
                    >
                        <img
                        src={item.image}
                        alt={item.name}
                        width={"100%"}
                        style={{ height: '40px', objectFit: 'contain' }}
                        />
                        <div className="mt-2 fw-semibold">{item.name}</div>
                    </div>
                    ))}
                </div>

                </div>
            </div>
        </div>
    );
}

export default Marketplace;
